import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import './styles/StatisticsChart.css';

const StatisticsChart = ({ regionesData = [] }) => {
  const COLORS = ['#a855f7', '#f97316', '#3b82f6', '#22c55e', '#ec4899', '#facc15'];
  const data = regionesData.map(item => ({
    name: item.region,
    value: Number(item.cantidad)
  }));

  return (
    <div className="statistics-chart">
      <div className="statistics-header">
        <h3 className="statistics-title">Ventas por Regiones</h3>
      </div>

      <div className="chart-container" style={{ width: '100%', height: 300 }}>
        {data.length > 0 ? (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={60} 
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                animationDuration={1000}
                label={({ name, value }) => `${name}: ${value}`}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
              />
              <Legend 
                verticalAlign="bottom" 
                height={36} 
                iconType="circle"
                wrapperStyle={{ fontSize: '12px', paddingTop: '10px' }}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="no-data-message">
            <p>No hay datos para este período</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatisticsChart;